export default {
  ['setAccessToken'](state, payload) {
    state.accessToken = payload
  },
}
